module.exports = __webpack_public_path__ + "static/media/flashbang.252a57ab.png";